import React, { FC, useState } from "react";
import { Redirect, Route, RouteComponentProps } from "react-router-dom";
import { isLogin } from "../../Common/Utils/common_utils";
import { useDispatch, useSelector } from "react-redux";
import { ACCESS_PERMISSION, GLOBAL_DATA } from "../../Redux/actions";
import axios from "axios";
import AuthClient from "../../Service/auth_services";
import { LoadingIndicator } from "react-select/src/components/indicators";
import Loader from "../../Components/Loader";


/**
 * Private route need auth before enter into this route else redirected on login
 * @param Component
 * @param rest
 * @constructor
 */
const PrivateRoute: FC<any> = ({ component: Component, ...rest }) => {
  //   const commonState = useSelector((state: any) => state.commonReducer);
  const dispatch = useDispatch();
  const globaluserData = useSelector((state: any) => state.commonReducer);
  const [loading, setLoading] = useState<boolean>(false);
  console.log("test", !globaluserData?.role, globaluserData.authHeaders);
  console.log("aa", globaluserData);
  if (
    !globaluserData?.role &&
    sessionStorage.getItem("authorization_headers") &&
     !loading
  ) {
    // debugger;
    setLoading(true);
    AuthClient.getUserDetails()
      .then((response: any) => {
        console.log("response", response);

        // debugger;
        dispatch({
          type: GLOBAL_DATA,
          payload: {
            userData: response.data,
            accessLevel: response.data.access_level,
            profile_logo: response.data.logo_url,
            role: response?.data?.role[0],
            employee_id: response.data.employee_id,
            organisation_id: response.data.organisation_id,
            organisation_name: response.data.organisation_name,
            authHeaders: sessionStorage.getItem("authorization_headers"),
          },
        });
        if (response?.data?.role[0] === "admin") {
          dispatch({ type: ACCESS_PERMISSION, payload: "" });
        } else {
          const accessLevel =
            globaluserData?.userData?.job_role_access_level?.find(
              (item: any) =>
                item.job_role === sessionStorage.getItem("jobRole") ||
                response?.data?.job_roles[0]
            )?.access_level;
          if (
            response?.data?.job_roles.includes(
              sessionStorage.getItem("jobRole")
            )
          ) {
            dispatch({
              type: GLOBAL_DATA,
              payload: {
                jobRole: sessionStorage.getItem("jobRole"),
                accessLevel: accessLevel,
              },
            });
          } else {
            dispatch({
              type: GLOBAL_DATA,
              payload: {
                jobRole: response?.data?.job_roles[0],
                accessLevel: accessLevel,
              },
            });
          }
          dispatch({
            type: ACCESS_PERMISSION,
            payload: accessLevel ? accessLevel.toLowerCase() : "",
          });
        }

        setLoading(false);
      })
      .catch((error: any) => {
        console.log(error);
      });
  }
  console.log("Loading", loading);
  return (
    <Route
      render={
        (props: RouteComponentProps) =>
          //   commonState.token ? (
          isLogin() ? (
            loading ? (
              <Loader/>
            ) : (
              <Component {...props} />
            )
          ) : (
            <Redirect to='/auth/login' />
          )
        // ) : (
        //   sessionStorage.clear()
        // )
      }
      {...rest}
    >
      {rest.children}
    </Route>
  );
};

export default PrivateRoute;
